import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { TextField } from "@mui/material";
import React, { useState } from "react";

interface EditableModalProps {
  selectedNote: string | null;
  saveNote: (editedNote: string) => void;
  open: boolean;
  onCloseModal: () => void;
}

const EditableModal: React.FC<EditableModalProps> = ({
  selectedNote,
  open,
  saveNote,
  onCloseModal
}) => {
  const [editedNote, setEditedNote] = useState(selectedNote || "");

  const handleSave = () => {
    saveNote(editedNote);
  };

  const trimmedEditedNote = editedNote.trim();
  const trimmedSelectedNote = (selectedNote || "").trim();

  const isUnchanged = trimmedEditedNote === trimmedSelectedNote;
  const wasPreviouslyEmpty = trimmedSelectedNote === "";
  const isNowEmpty = trimmedEditedNote === "";

  const shouldDisableSave =
    (isUnchanged && isNowEmpty) || (!wasPreviouslyEmpty && isUnchanged);

  return (
    <Dialog open={open} onClose={onCloseModal} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Note</DialogTitle>
      <DialogContent>
        <TextField
          multiline
          fullWidth
          value={editedNote}
          onChange={(e) => setEditedNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseModal} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          disabled={shouldDisableSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditableModal;
